import { useSelector } from 'react-redux';
import Workspace from 'src/entities/workspace';
import { getWorkspace } from 'src/selectors/workspaces';
import ScimProvisioningCard from './ScimProvisioningCard';
import ScimSyncHistory from './ScimSyncHistory';
import ScimEnterprisePaywall from './ScimEnterprisePaywall';
import ScimNonOwnerCard from './ScimNonOwnerCard';

import './WorkspaceProvisioningTab.scss';

const WorkspaceProvisioningTab = ( { workspaceID }: { workspaceID: number } ) => {
	// @ts-expect-error - TODO: fix this
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	const workspace: Workspace = useSelector( ( state: any ) => getWorkspace( state, { workspaceID } ) );

	const renderContent = () => {
		if ( !workspace.scimManageableByCurrentUser ) return <ScimNonOwnerCard />;
		if ( workspace.scimEnabled ) {
			return (
				<>
					<ScimProvisioningCard workspaceID={workspaceID} />
					<ScimSyncHistory workspaceID={workspaceID} />
				</>
			);
		}
		return <ScimEnterprisePaywall />;
	};

	return (
		<div className="WorkspaceProvisioningTab">
			{renderContent()}
		</div>
	);
};

export default WorkspaceProvisioningTab;
